import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cookieToObject } from '../../helpers/auth';

export const tags = [
    "ModuleConfig",
    "ServerTimeZone",
    "CompanyInfo",
    "BookingConfig",
    "Person",
    "User",
    "Profile",
    "ContactMethod",
    "Accessory",
    "Company",
    "Booking",
    "Share",
    "Purchase",
    "StaffManagement",
    "AccountProfile",
    "Location",
    "Jail",
    "Tickets",
    "FormLetters",
    "Car",
];

function prepareHeaders(headers: Headers) {
    // Below is taken pretty much wholesale (except for a call to populate
    // the access_token if it's missing) from existing api code.
    const cookies: { [key: string]: any } = cookieToObject();

    // Staff will save their initial hash to the cookie and not update it as they jump from different member profiles to masquerade as.
    // Members will update their profile hash everytime they switch their profile.
    const profileHash = cookies["profile_hash"];
    headers.set("Accept", "application/json");
    headers.set("Content-Type", "application/json");
    headers.set("Profile", profileHash);
    return headers;
}

const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: window.env.BACKEND_API_URL,
        prepareHeaders,
        credentials: 'include',
    }),
    tagTypes: tags,
    endpoints: () => ({})
});

export const { endpoints } = apiSlice;

export { apiSlice, prepareHeaders };
